export default "<ion-nav #allocationForm [ngClass]=\"{'centered':isViewCentered}\"></ion-nav>\n";